import React, {useRef, useEffect, useState, useImperativeHandle, forwardRef} from 'react';
import { 
    Box, Grid, GridItem,
    Button, Text, Flex, Heading, Textarea, FormControl, 
    Menu, MenuButton, MenuList, MenuItem, 
    Icon, Link, Tooltip, useClipboard,
    HStack,
    VStack,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';  // Importing arrow icon
import { IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import apiClient from '../../clients/apiClient.js';
import { DownloadFile2 } from '../../components/DownloadFile.js';
import addCollaboratorIcon from './AddCollaborator.svg'
import CollaboratorModal from './CollaboratorModal.js';
import ConversationCards from './ConversationCards.js';

import { GetFormEntityObject, BuildEntityAnswerObjectFromAnswers } from "./FormEntityObj.js"
import { CategoryOutlined, Chat, ChatOutlined, DoneAllOutlined, EditOutlined, OpenInNewOutlined, PersonAdd, PersonAddAltOutlined, ThumbDownOutlined, ThumbUp, ThumbUpOutlined } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
 
const QuestionCard = forwardRef(({
  questionData, 
  updateQuestionData, 
  addConversationToQuestionData,
  updateQuestionIndex, 
  setUpdatedData, 
  scrollToQuestionCard,
  setScrollToQuestionCard,
  filterType,
  allCollaborators,
  isCollaborator,
  setIsEntityChatOpen,
  setEntityChatData,
  refId,
  setSelectedRefId,
  selectedConversationTab,
  setSelectedConversationTab,
}, ref) => {
  const [isChatOpen, setIsChatOpen] = React.useState(false);
  const questionCardRef = React.useRef(null);
  const [questionBoxHeight, setQuestionBoxHeight] = useState("auto");
  const [allConversations, setAllConversations] = useState([])
  const [currentMessages, setCurrentMessages] = useState([])
  const [currentConversation, setCurrentConversation] = useState("")
  const [showCancel, setShowCancel] = React.useState(false);
  const [prevQuestionData, setPrevQuestionData] = React.useState(null);
  const [usingSuggestions, setUsingSuggestions] = React.useState(false);
  const {formId} = useParams();

  useImperativeHandle(ref, () => ({
    applySuggestion(suggestionAnswers) {
      if (usingSuggestions) {
        return 
      }
      setUsingSuggestions(true)
      const tempQuestionData = structuredClone(questionData);
      let data = GetFormEntityObject(questionData.id, "unapproved", BuildEntityAnswerObjectFromAnswers(suggestionAnswers))
      console.log("[Form] suggestion data is", data)
      console.log("[Form] question data is", questionData)
      // setUpdatedData((prevData) => {
          // let newData = []
          // for (let i = 0; i < prevData.length; i++ ) {
          //     if (data.entity_id !== prevData[i].entity_id) {
          //         newData = [...newData, prevData[i]]
          //     }
          // }
          // newData = [...newData, data]
  
          // console.log("[Form] new data is", newData)
      //     return prevData
      // })
      for (let i = 0; i < data.answers.length; i++) {
        for (let j = 0; j < questionData.answers.length; j++) {
          if (data.answers[i].header == questionData.answers[j].header) {
            questionData.answers[j].value = data.answers[i].value
            break
          }
        }
      }
      questionData.state = "unfilled"
      setShowCancel(true)
      setPrevQuestionData(tempQuestionData)
    }
  }))

  const sendApproveAnswerMessage = () => {
    let collaboratorChat = null;
    for (let i = 0; i < questionData.conversations?.length; i++) {
        if (questionData.conversations[i].conversation_type == "collaborator_chat") {
            collaboratorChat = questionData.conversations[i]
            break
        }
    }

    console.log("[Form] collaborator chat is", questionData, collaboratorChat)
    if (collaboratorChat == null || collaboratorChat?.messages?.length === 0) {
        apiClient.post('/forms/take-form-action', {
            form_id: formId,
            entity_id: questionData.id,
            action_type: "start_conversation",
            action_data: {
                start_conversation: {
                    message_type: "mark_approved",
                    conversation_type: "collaborator_chat"
                }
            }
        }).then((response) => {
            setAllConversations((prev) => {
                const updatedConversations = [...(prev || [])];
                updatedConversations[updatedConversations.length] = response.data;
                return updatedConversations;
            })

            questionData.conversations = [...(questionData.conversations || []), response.data]
        })
    } else {
        apiClient.post('/forms/take-form-action', {
            form_id: formId,
            entity_id: questionData.id,
            action_type: "reply",
            action_data: {
                reply: {
                    conversation_id: collaboratorChat.conversation_id,
                    conversation_type: "collaborator_chat",
                    message_type: "mark_approved",
                }
            }
        }).then((response) => {
            setAllConversations((prev) => {
                const updatedConversations = prev.map(convo => {
                    if (convo.conversation_id === collaboratorChat.conversation_id) {
                        return {
                            ...convo,
                            messages: [...convo.messages, response.data.messages[0]]
                        };
                    }
                    return convo;
                });

                console.log("[Form] updated conversations are", updatedConversations)
                return updatedConversations;
            })
            
            for (let i = 0; i < questionData.conversations?.length; i++) {
                if (questionData.conversations[i].conversation_id == collaboratorChat.conversation_id) {
                    questionData.conversations[i].messages = [...questionData.conversations[i].messages, response.data.messages[0]]
                    break
                }
            }
        })
    }
  }

  const sendSuggestion = (data) => {
    let collaboratorChat = null;
    for (let i = 0; i < questionData.conversations?.length; i++) {
        if (questionData.conversations[i].conversation_type == "collaborator_chat") {
            collaboratorChat = questionData.conversations[i]
            break
        }
    }

    if (collaboratorChat == null || collaboratorChat?.messages?.length === 0) {
        apiClient.post('/forms/take-form-action', {
            form_id: formId,
            entity_id: questionData.id,
            action_type: "start_conversation",
            action_data: {
                start_conversation: {
                  conversation_type: "collaborator_chat",
                    message_type: "entity_answer",
                    message_data: {
                      entity_answer: data.answers
                    }
                }
            }
        }).then((response) => {
            setAllConversations((prev) => {
                const updatedConversations = [...(prev || [])];
                updatedConversations[updatedConversations.length] = response.data;
                return updatedConversations;
            })

            questionData.conversations = [...(questionData.conversations || []), response.data]
        })
    } else {
        apiClient.post('/forms/take-form-action', {
            form_id: formId,
            entity_id: questionData.id,
            action_type: "reply",
            action_data: {
                reply: {
                    conversation_id: collaboratorChat.conversation_id,
                    conversation_type: "collaborator_chat",
                    message_type: "entity_answer",
                    message_data: {
                      entity_answer: data.answers
                    }
                }
            }
        }).then((response) => {
            setAllConversations((prev) => {
                const updatedConversations = prev.map(convo => {
                    if (convo.conversation_id === collaboratorChat.conversation_id) {
                        return {
                            ...convo,
                            messages: [...convo.messages, response.data.messages[0]]
                        };
                    }
                    return convo;
                });

                console.log("[Form] updated conversations are", updatedConversations)
                return updatedConversations;
            })
            
            for (let i = 0; i < questionData.conversations?.length; i++) {
                if (questionData.conversations[i].conversation_id == collaboratorChat.conversation_id) {
                    questionData.conversations[i].messages = [...questionData.conversations[i].messages, response.data.messages[0]]
                    break
                }
            }
        })
    }
  }

  React.useEffect(() => {
    setAllConversations(questionData?.conversations)
  }, [])

  React.useEffect(() => {
      if (questionCardRef.current) {
          setQuestionBoxHeight(questionCardRef.current.offsetHeight);
      }
  }, [questionData]);

  return (
    <Box w="100%" display="flex" justifyContent="center">
      <BaseCard 
        questionData={questionData} 
        updateQuestionData={updateQuestionData} 
        updateQuestionIndex={updateQuestionIndex} 
        setUpdatedData={setUpdatedData} 
        scrollToQuestionCard={scrollToQuestionCard}
        setScrollToQuestionCard={setScrollToQuestionCard}
        filterType={filterType}
        allCollaborators={allCollaborators}
        isChatOpen={isChatOpen}
        setIsChatOpen={setIsChatOpen}
        questionCardRef={questionCardRef}
        allConversations={allConversations}
        isCollaborator={isCollaborator}
        sendSuggestion={sendSuggestion}
        showCancel={showCancel}
        setShowCancel={setShowCancel}
        prevQuestionData={prevQuestionData}
        setPrevQuestionData={setPrevQuestionData}
        setUsingSuggestions={setUsingSuggestions}
        sendApproveAnswerMessage={sendApproveAnswerMessage}
        setIsEntityChatOpen={setIsEntityChatOpen}
        setEntityChatData={setEntityChatData}
        refId={refId}
        setSelectedRefId={setSelectedRefId}
        selectedConversationTab={selectedConversationTab}
        setSelectedConversationTab={setSelectedConversationTab}
      />
      {/* <ConversationCards 
        isChatOpen={isChatOpen} 
        questionData={questionData} 
        questionBoxHeight={questionBoxHeight}
        allConversations={allConversations}
        setAllConversations={setAllConversations}
        currentMessages={currentMessages}
        setCurrentMessages={setCurrentMessages}
        currentConversation={currentConversation}
        setCurrentConversation={setCurrentConversation}
        applySuggestion={applySuggestion}
        usingSuggestions={usingSuggestions}
      /> */}
    </Box>
  )
})


const BaseCard = ({
  questionData, 
  updateQuestionData, 
  updateQuestionIndex, 
  setUpdatedData, 
  scrollToQuestionCard,
  setScrollToQuestionCard,
  filterType,
  allCollaborators,
  isChatOpen,
  setIsChatOpen,
  questionCardRef,
  allConversations,
  isCollaborator,
  sendSuggestion,
  showCancel,
  setShowCancel,
  prevQuestionData,
  setPrevQuestionData,
  setUsingSuggestions,
  sendApproveAnswerMessage,
  setIsEntityChatOpen,
  setEntityChatData,
  refId,
  setSelectedRefId,
  selectedConversationTab,
  setSelectedConversationTab,
}) => {  
  const [isOpen, setIsOpen] = React.useState(true);
  const [currentQuestionData, setCurrentQuestionData] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [existingCollaborators, setExistingCollaborators] = useState([]);
  
  const getCollaboratorFromEmail = (email) => {
      return allCollaborators.find((collaborator) => collaborator.email === email);
  }

  React.useEffect(() => {
      const collaborators = questionData.collaborators.map((collaborator) =>
          getCollaboratorFromEmail(collaborator)
      );
      setExistingCollaborators(collaborators);
  }, [])

  React.useEffect(() => {
    if (scrollToQuestionCard == questionData.id) {
      questionCardRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
      setScrollToQuestionCard(null)
    }
  }, [scrollToQuestionCard])


  React.useEffect(() => {
    setCurrentQuestionData(questionData)
  }, [])

  if (filterType == "unfilled" && questionData.state != "unfilled") {
    return null
  } else if (filterType == "unreviewed" && questionData.state != "unapproved") {
    return null
  } else if (filterType == "completed" && questionData.state != "approved") {
    return null
  }

  const getTotalMessages = () => {
    let totalMessages = 0
    for (let i = 0; i < allConversations?.length; i++) {
      totalMessages += allConversations[i].messages.length
    }
    return totalMessages
  }

  const updateAnswerValue = ({updateIndex, inputAnswerValue}) => {
        let tempData = questionData
        for (let i = 0; i < tempData.answers.length; i++) {
            if (i == updateIndex) {
                tempData.answer[i].value = inputAnswerValue
                break
            }
        }

        updateQuestionData(updateQuestionIndex, tempData)
  }

  const RenderHDividers = ({dataPoints}) => {
      let dividers = [];
      for(let i = 1; i < dataPoints?.length; i++ ) {
      dividers.push(
          <Box
          key={i}
          gridColumn="1 / span 2" // Spans across all columns
          gridRow={`${i} / ${i+1}`} // Positioned between the first and second rows
          height="1px"
          bg="#E5E5E5"
          // transform="translateY(+250%)"
          alignSelf="end" // Aligns to the bottom of the first row
          />
      )
      }
      return dividers;
  }

  const approveAnswer = () => {
      console.log("[Form] question data approved", questionData)
      console.log("[Form] approved")
      let data = GetFormEntityObject(questionData.id, "approved", BuildEntityAnswerObjectFromAnswers(questionData.answers))
      console.log("[Form] approved data is", data)
      setUpdatedData((prevData) => {
          let newData = []
          for (let i = 0; i < prevData.length; i++ ) {
              if (data.entity_id !== prevData[i].entity_id) {
                  newData = [...newData, prevData[i]]
              }
          }
          newData = [...newData, data]

          return newData
      })
      questionData.state = "approved"
      setCurrentQuestionData(questionData)
  }

  const unapproveAnswer = () => {
      console.log("[Form] question data unapproved", questionData)
      console.log("[Form] unapproved")
      let data = GetFormEntityObject(questionData.id, "unapproved", BuildEntityAnswerObjectFromAnswers(questionData.answers))
      console.log("[Form] unapproved data is", data)
      setUpdatedData((prevData) => {
          let newData = []
          for (let i = 0; i < prevData.length; i++ ) {
              if (data.entity_id !== prevData[i].entity_id) {
                  newData = [...newData, prevData[i]]
              }
          }
          newData = [...newData, data]

          return newData
      })
      questionData.state = "unapproved"
      setCurrentQuestionData(questionData)
  }

  const saveAnswer = () => {
    let data = GetFormEntityObject(questionData.id, "unapproved", BuildEntityAnswerObjectFromAnswers(questionData.answers))
    console.log("[Form] unapproved data is", data)
    setUpdatedData((prevData) => {
        let newData = []
        for (let i = 0; i < prevData.length; i++ ) {
            if (data.entity_id !== prevData[i].entity_id) {
                newData = [...newData, prevData[i]]
            }
        }
        newData = [...newData, data]

        return newData
    })
    questionData.state = "unapproved"
    setCurrentQuestionData(questionData)
  }

  const suggestAnswer = () => {
    let data = GetFormEntityObject(questionData.id, "unapproved", BuildEntityAnswerObjectFromAnswers(questionData.answers))
    sendSuggestion(data)
    questionData.state = "unapproved"
  }

  const editAnswer = () => {
    let tempData = structuredClone(questionData)
    setPrevQuestionData(tempData)
    setShowCancel(true)
    console.log("[Form][cancel] prevQuestionData2 is ", tempData)
    questionData.state = "unfilled"
    setCurrentQuestionData(questionData)
  }

  const cancelEdit = () => {
    // setShowCancel(false)
    console.log("[Form][cancel] prevQuestionData is ", prevQuestionData)
    questionData.state = prevQuestionData.state
    questionData.answers = prevQuestionData.answers
    setCurrentQuestionData(prevQuestionData)
    setUsingSuggestions(false)
    // updateQuestionData(updateQuestionIndex, prevQuestionData)
  }

  const isDataApproved = () => {
    if (questionData?.state == "approved") {
      return true
    }

    return false
  }

  const GetCollapsedText = ({questionData}) => {
    let text = "";
    questionData?.questions?.sort((a,b) => a.display_order - b.display_order).map((question, i) => {
      text += i ? " - " : ""
      text += question.value
    })

    return (
      <Text 
        isTruncated 
        overflow={"hidden"} 
        flexShrink={1} 
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        maxWidth={"100%"}
      >
        {text}
      </Text>
    )
  }

  return (
  <Box
      ref={questionCardRef}
      fontFamily="Arial, sans-serif"
      margin="10px"
      width={isChatOpen ? "60%" : "80%"}  
      maxHeight={"80%"}
      maxWidth={"80%"}
      minWidth="400px"
      // maxWidth="80hw"
      borderWidth="1px"
      borderRadius="lg"
      padding="20px"
      bgColor="#F6FAFF"
  >
  {isOpen ? (
    <Box w={"100%"}>
      {/* Questions Section */}
      <Box marginBottom="20px">
        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignContent="center">
          <Heading size="md" marginBottom="8px" fontSize={"16px"} fontWeight={"semibold"}>Questions</Heading>
          </Flex>
          <Flex alignContent="flex-end" position="relative" alignItems="center">
          {
            !isCollaborator && (
              <IconButton 
                sx={{
                  padding:0,
                  width:"20px",
                  height:"20px",
                  "&:hover": { backgroundColor: "transparent"}
                }}
                onClick={() => setIsModalOpen(true)} // Open modal on click
              >
                {existingCollaborators.length > 0 && (
                  <Box
                  position="absolute"
                  top="-8px"
                  right="-8px"
                  bg="red.500"
                  color="white"
                  borderRadius="full"
                  fontSize="10px"
                  fontWeight="bold"
                  width="16px"
                  height="16px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  >
                  {existingCollaborators.length}
                  </Box>
                )}
                <PersonAddAltOutlined sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }} />
              </IconButton>
            )
          }

          {questionData?.state != "unfilled" && (
            <IconButton 
              sx={{ 
                padding:0,
                width:"20px",
                height:"20px",
                marginLeft: "8px",
                "&:hover": { backgroundColor: "transparent"},
              }}
              onClick={() => editAnswer()} 
            >
              <EditOutlined sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }} />
            </IconButton>
          )}
          <IconButton 
            sx={{ padding:0, width:"20px", height:"20px", color: "#5d5d5d", marginLeft: "8px"}} 
            onClick={() => {
              setEntityChatData(questionData)
              setSelectedRefId(refId)
              setSelectedConversationTab("collaborator_chat")
              setIsEntityChatOpen(true)
            }}
          >
            {getTotalMessages() > 0 && (
              <Box
                position="absolute"
                top="-8px"
                right="-8px"
                bg="red.500"
                color="white"
                borderRadius="full"
                fontSize="10px"
                fontWeight="bold"
                width="16px"
                height="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
              {getTotalMessages()}
              </Box>
            )}
            { isChatOpen ? <Chat sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }}/> : <ChatOutlined sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }}/> }
          </IconButton>
          <IconButton 
            sx={{ padding:0, fontSize: "20px", color: "#5d5d5d", marginLeft: "8px" }} 
            onClick={() => setIsOpen((prevState) => !prevState)}
          >
            { isOpen ? <ExpandMoreIcon sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }}/> : <ExpandLessIcon sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }}/> }
          </IconButton>
          </Flex>
        </Flex>
        <Grid
          templateColumns="1fr 2fr"
          templateRows={`repeat(${questionData?.questions?.length}, auto)`}
          gap={0}
          p={1}
        >
          {questionData?.questions?.sort((a,b) => a.display_order - b.display_order).map((question, i)=> (
          <Column1GridItem text={question.header} key={i*2+1} row={i+1} column='1'/>
          ))}

          {questionData?.questions?.sort((a,b) => a.display_order - b.display_order).map((question, i)=> (
          <Column2GridItem text={question.value} key={i*2+2} row={i+1} column='2'/>
          ))}

          {/* Modal */}
          {isModalOpen && (
            <CollaboratorModal 
              isModalOpen={isModalOpen} 
              setIsModalOpen={setIsModalOpen} 
              allCollaborators={allCollaborators} 
              questionData={questionData}
              existingCollaborators={existingCollaborators}
              setExistingCollaborators={setExistingCollaborators}
            />
          )}
            <RenderHDividers dataPoints={questionData?.questions} />

            {/* Vertical Divider */}
            <Box
            gridColumn="1 / 2" // Positioned between the first and second columns
            gridRow={`1 / span ${questionData?.questions?.length}`} // Spans all rows
            width="1px"
            // transform="translateX(+250%)"
            bg="#E5E5E5"
            justifySelf="end" // Aligns to the right of the first column
            />
        </Grid>
      </Box>

        {/* Answers Section */}
      <Box marginBottom="20px">
        <Heading size="md" marginBottom="8px" fontSize={"16px"} fontWeight={"semibold"}>Answers</Heading>
        <Grid
            templateColumns="1fr 2fr"
            templateRows={`repeat(${questionData?.answers?.length}, auto)`}
            gap={0}
            p={1}
        >
            {questionData?.answers?.sort((a,b) => a.display_order - b.display_order).map((answer, i)=> (
            <Column1GridItem text={answer.header} key={i*2+1} row={i+1} column='1'/>
            ))}
            {questionData?.answers?.sort((a,b) => a.display_order - b.display_order).map((answer, i)=> (
            <Column2InputGridItem 
                value={answer.value} 
                references={answer.references}
                key={i*2+2} 
                row={i+1} 
                column='2' 
                updateAnswerValue={updateAnswerValue} updateIndex={i}
                isDisabled={!(questionData?.state == "unfilled")}
            />
            ))}

            {/* Horizontal Divider */}
            <RenderHDividers dataPoints={questionData?.answers} />

            {/* Vertical Divider */}
            <Box
            gridColumn="1 / 2" // Positioned between the first and second columns
            gridRow={`1 / span ${questionData?.answers?.length}`} // Spans all rows
            width="1px"
            // transform="translateX(+250%)"
            bg="#E5E5E5"
            justifySelf="end" // Aligns to the right of the first column
            />
        </Grid>
      </Box>

        <Flex justifyContent="flex-end" gap={0}>

        {console.log("[Form] question data is", showCancel)}
        {questionData?.state == "unfilled" && showCancel && (
          <Button height={"32px"} bg="transparent" fontWeight={"500"} color="#1d1d1d" _hover={{
            backgroundColor: "transparent",
          }} onClick={() => cancelEdit()}>Cancel</Button>
        )}

        {!isCollaborator && questionData?.state == "unfilled" && (
          <Button height={"32px"} bg="transparent" fontWeight={"500"} color="#2584FD" _hover={{
            backgroundColor: "transparent",
          }} onClick={() => saveAnswer()}>Save</Button>
        )}

        {
          isCollaborator && questionData?.state == "unfilled" && (
            <Button height={"32px"} bg="transparent" fontWeight={"500"} color="#2584FD" _hover={{
              backgroundColor: "transparent",
            }} onClick={() => suggestAnswer()}>Suggest</Button>
          )
        }

        {!isCollaborator && questionData?.state == "unapproved" && (
          <>
            <Button
              width={"187px"}
              height={"40px"}
              paddingX={"16px"}
              paddingY={"8px"}
              border={"1px solid #CDCDCD"}
              borderRadius={"4px"}
              bg="transparent"
              _hover={{ backgroundColor: "#F6FAFF" }}
            >
              <IconButton
                sx={{ padding:0, fontSize: "16px", color: "#5D5D5D" }}
              >
                <ThumbDownOutlined sx={{ padding:0, fontSize: "16px", color: "#5D5D5D" }} />
              </IconButton>
              <Text
                marginLeft={"4px"}
                height={"22px"}
                fontSize={"14px"}
                color={"#5D5D5D"}
                fontWeight={"500"}
                onClick={() => {
                  setEntityChatData(questionData)
                  setSelectedRefId(refId)
                  setSelectedConversationTab("ai_chat")
                  setIsEntityChatOpen(true)
                }}
              >
                Needs improvement
              </Text>
            </Button>
            <Button
              marginLeft={"16px"}
              width={"131px"}
              height={"40px"}
              paddingX={"16px"}
              paddingY={"8px"}
              border={"1px solid #2584FD"}
              borderRadius={"4px"}
              bg="transparent"
              _hover={{ backgroundColor: "#F6FAFF" }}
              onClick={() => approveAnswer()}
            >
              <IconButton
                sx={{ padding:0, fontSize: "16px", color: "#2584FD" }}
              >
                <ThumbUpOutlined sx={{ padding:0, fontSize: "16px", color: "#2584FD" }} />
              </IconButton>
              <Text
                marginLeft={"4px"}
                height={"22px"}
                fontSize={"14px"}
                color={"#2584FD"}
                fontWeight={"500"}
              >
                Looks Good
              </Text>
            </Button>
          </>
        )}

        {isCollaborator && questionData?.state == "unapproved" && (
            <Button
              marginLeft={"16px"}
              width={"131px"}
              height={"40px"}
              paddingX={"16px"}
              paddingY={"8px"}
              border={"1px solid #2584FD"}
              borderRadius={"4px"}
              bg="transparent"
              _hover={{ backgroundColor: "#F6FAFF" }}
              onClick={() => sendApproveAnswerMessage()}
            >
              <IconButton
                sx={{ padding:0, fontSize: "16px", color: "#2584FD" }}
              >
                <ThumbUpOutlined sx={{ padding:0, fontSize: "16px", color: "#2584FD" }} />
              </IconButton>
              <Text
                marginLeft={"4px"}
                height={"22px"}
                fontSize={"14px"}
                color={"#2584FD"}
                fontWeight={"500"}
              >
                Looks Good
              </Text>
            </Button>
          // <Button size="sm" colorScheme="green" onClick={() => sendApproveAnswerMessage()}>Send Approval</Button>
        )}

        {isDataApproved() && (
            <Button
              marginLeft={"16px"}
              width={"131px"}
              height={"40px"}
              paddingX={"16px"}
              paddingY={"8px"}
              // border={"1px solid #2584FD"}
              // borderRadius={"4px"}
              bg="transparent"
              _hover={{ backgroundColor: "#F6FAFF" }}
              onClick={() => unapproveAnswer()}
            >
              <IconButton
                sx={{ padding:0, fontSize: "16px", color: "#009652" }}
              >
                <ThumbUp sx={{ padding:0, fontSize: "16px", color: "#009652" }} />
              </IconButton>
              <Text
                marginLeft={"4px"}
                height={"22px"}
                fontSize={"14px"}
                color={"#009652"}
                fontWeight={"500"}
              >
                Looks Good
              </Text>
            </Button>
        )}

        </Flex>
    </Box>
    ) : (
        <Box maxWidth={"100%"}>
          <Flex justifyContent="space-between" maxWidth={"100%"}>
            {/* <Flex alignContent="flex-start" gap={"10px"} overflow="hidden"> */}
              <Heading
                alignContent="flex-start"
                size="md" 
                // isTruncated 
                whiteSpace="nowrap" 
                overflow="hidden"
                maxWidth={"50%"}
              >
                <GetCollapsedText questionData={questionData} />
              </Heading>
            {/* </Flex> */}
            <Flex alignContent="flex-end" maxWidth={"10%"}>
              <IconButton 
                sx={{ padding:0, fontSize: "24px", color: "#adadad", marginRight:"16px" }} 
                onClick={() => setIsOpen((prevState) => !prevState)}
              >{ isOpen ? <ExpandMoreIcon/> : <ExpandLessIcon/> }</IconButton>
            </Flex>
          </Flex>
        </Box>
    )
    // <Box 
    //     fontFamily="Arial, sans-serif"
    //     margin="20px"
    //     width="80%"
    //     minWidth="400px"
    //     borderWidth="1px"
    //     borderRadius="lg"
    //     padding="20px"
    //     bgColor="#FAFAFF"
    // >
  }
  </Box>)
}

const Column1GridItem = ({text, key, row, column}) => {
    return (
      <GridItem
        key={key}
        gridRow={row}
        gridColumn={column}
        bg="#FFFFFF"
        p={0} 
        overflowY="auto"
        display="grid"
        justifyContent={"left"}
        alignContent={"top"}
      >
      <Flex justifyContent="space-between" paddingX={"24px"} paddingY={"16px"}>
        <Text fontFamily={"sans-serif"} fontSize={"14px"} padding={"0px"} color={"#1D1D1D"} >{text}</Text>
      </Flex>
      </GridItem>
    )
}
  
const Column2GridItem = ({text, key, row, column}) => {
    return (
      <GridItem 
        bg="#FFFFFF"
        p={0} 
        overflowY="auto"
        display="grid"
        placeItems="left"
        key={key}
        gridRow={row}
        gridColumn={column}
          // margin="4px"
      >
        <Box
          display="flex"
          alignItems="center" // Center on the Y-axis
          height="100%" // Parent container height
          bg="#FFFFFF"
          px="12px" // Padding to create space for the left alignment
          py="12px"
        >
          <Text fontSize={"14px"} fontFamily={"sans-serif"} color={"#1D1D1D"}>
            {text}
          </Text>
        </Box>
      </GridItem>
    )
}
  
const Column2InputGridItem = ({value, references, key, row, column, updateAnswerValue, updateIndex, isDisabled}) => {
  console.log("[Form][reference] References are", references)
  const [renderSnippet, setRenderSnippet] = React.useState(null)

  const setCurrentChosen = (optionValue) => {
        let newValue = value
        newValue.option.current_chosen = optionValue
        updateAnswerValue(updateIndex, newValue)
    }

    const setText = (text) => {
        console.log("[Form][Cancel] text in snippet is",text)
        let newValue = value
        newValue.text = text
        value.text = text
        setRenderSnippet(text)
        // updateAnswerValue(updateIndex, newValue)
    }

    const renderContent = () => {
      switch (value.type) {
        case "text":
            console.log("Form][Cancel] Text is",value.text)
          return <ParaInput setText={setText} currentText={value.text} isDisabled={isDisabled}/>;
        case "option": {
            let currentChosen = ''
            if (value.option.current_chosen == '') {
                currentChosen = value.option.default
            } else {
                currentChosen = value.option.current_chosen
            }
            return <OptionInput option={value.option} currentChosen={currentChosen} setCurrentChosen={setCurrentChosen}/>;
        }
        default:
          return <ParaInput setText={setText} isDisabled={isDisabled}/>;
      }
    };

    const DisplayFile = ({filename, fileId}) => {
    return (
      <Tooltip label={filename} 
        placement='top'
        bg={"#8d8d8d"}
        color={"#f2f2f2"}
        fontWeight={500}
        fontFamily="'Inter', sans-serif" 
        offset={[0, -3]}
      >
        <Link
          onClick={() => DownloadFile2(fileId, filename)}
          fontWeight="regular"
          cursor={'pointer'}
          color={"#2584FD"}
        >
          <Text px={"2px"} fontSize="14px" fontFamily={"sans-serif"} isTruncated maxWidth={"120px"}>{filename}</Text>
        </Link>
      </Tooltip>
    )
  }

  const DisplayLink = ({linkname, linkId}) => {
    return (
      <Tooltip label={linkname} 
        placement='top'
        bg={"#8d8d8d"}
        color={"#f2f2f2"}
        fontWeight={500}
        fontFamily="'Inter', sans-serif" 
        offset={[0, -3]}
      >
        <Link
          href={linkId}
          isExternal
          fontWeight="regular"
          cursor={'pointer'}
          color={"#2584FD"}
        >
          <Text px={"2px"} fontSize="14px" fontFamily={"sans-serif"} isTruncated maxWidth={"120px"}>{linkname}</Text>
        </Link>
      </Tooltip>
    )
  }

    const renderReferences = () => {
      if (references == null) {
        return null
      }
      
      if (references.length == 0) {
        return null
      }

      return (
        <Menu placement="top">
          <MenuButton as={Button} color="#F6F8FA" borderRadius={"20px"} height={"24px"} justifyContent={"center"} alignContent={"center"} paddingX={"8px"}>
            <HStack height="16px" alignItems="flex-start" gap="2px">

              <IconButton 
                sx={{ paddingX: 0, marginX: "2px", fontSize: "14px", color: "#2584FD", height: "14px", minWidth: "14px" }}
              >
                <CategoryOutlined sx={{ padding: 0, fontSize: "14px" }}/>
              </IconButton>
              <Text 
                color="#2584FD" 
                fontSize="14px" 
                lineHeight="16px" 
                alignSelf="flex-start"
                fontFamily={"'Inter', sans-serif"}
              >
                {references.length} {references.length == 1 ? "source" : "sources"}
              </Text>

              <IconButton 
                sx={{ padding: 0, fontSize: "16px", color: "#2584FD", height: "16px", minWidth: "16px" }}
              >
                <ExpandMoreIcon sx={{ padding: 0, fontSize: "16px" }}/>
              </IconButton>
            </HStack>
          </MenuButton>
          <MenuList minW="unset">
            {references.map((reference, i) => {
              switch (reference.type) {
                case "file": {
                  return (
                    <MenuItem>
                      {reference.file.highlighted_text && (
                        <>
                          <Tooltip label={reference.file.highlighted_text} 
                            placement='top'
                            bg={"#8d8d8d"}
                            color={"#f2f2f2"}
                            fontWeight={500}
                            fontFamily="'Inter', sans-serif" 
                            offset={[0, -3]}
                            >
                            <Text isTruncated maxW={"256px"} px={"2px"} fontSize="14px" fontFamily={"sans-serif"}>
                              {reference.file.highlighted_text}
                            </Text>
                          </Tooltip>
                          <Text px={"2px"} fontSize="14px" fontFamily={"sans-serif"}>in</Text>
                        </>
                      )}
                      <DisplayFile fileId={reference.file.id} filename={reference.file.name} />
                      <IconButton 
                        sx={{ padding:0, fontSize: "16px", color: "#2584FD"}}
                      ><OpenInNewOutlined sx={{padding:0, fontSize: "16px"}} /></IconButton>
                    </MenuItem>
                  )
                }
                case "link": {
                  return (
                    <MenuItem>
                      {reference.link.highlighted_text && (
                        <>
                          <Tooltip label={reference.link.highlighted_text} 
                            placement='top'
                            bg={"#8d8d8d"}
                            color={"#f2f2f2"}
                            fontWeight={500}
                            fontFamily="'Inter', sans-serif" 
                            offset={[0, -3]}
                            >
                            <Text isTruncated maxW={"256px"} px={"2px"} h={"24px"}>
                              {reference.link.highlighted_text}
                            </Text>
                          </Tooltip>
                          <Text px={"2px"}>in</Text>
                        </>
                      )}
                      <DisplayLink linkId={reference.link.id} linkname={reference.link.name} />
                      <IconButton 
                        sx={{ padding:0, fontSize: "16px", color: "#2584FD"}}
                      ><OpenInNewOutlined sx={{padding:0, fontSize: "16px"}} /></IconButton>
                    </MenuItem>
                  )
                }
              }
            })}
          </MenuList>
        </Menu>
      )
    }
  
    return (
      <GridItem 
        bg="#FFFFFF"
        p={0} 
        overflowY="auto"
        display="grid"
        placeItems="left"
        key={key}
        gridRow={row}
        gridColumn={column}
      >
        {renderContent()}
        <Box marginX={"16px"} marginY={"8px"}>
          {renderReferences()}
        </Box>
      </GridItem>
    )
}
  
const ParaInput = ({setText, currentText, isDisabled}) => {
    const textAreaRef = useRef(null);

    const adjustHeight = () => {
      const textarea = textAreaRef.current;

      // Reset height to recalculate
      textarea.style.height = "auto";

      // Set new height based on scroll height
      textarea.style.height = `${textarea.scrollHeight}px`;
    }

    const handleInputChange = (e) => {
      setText(e.target.value); // Update state with the textarea value
      adjustHeight()
    };

    React.useEffect(() => {
      adjustHeight()
    }, [currentText])

    console.log("current text is",currentText)
    return ( 
      <Box width="100%" height="100%">
        <FormControl p={"0px"} 
          sx={{
            minHeight: "10px",
            maxHeight: "240px",
          }}
        >
          <Textarea
            ref={textAreaRef}
            value={currentText}
            placeholder="Type your answer here..."
            pY={"0px"}
            fontSize={"14px"}
            color={"#1D1D1D"}
            size="md"
            justifyContent={"center"}
            alignContent={"top"}
            resize="vertical" // Allows vertical resizing (default)
            focusBorderColor="blue.500" // Border color on focus
            border="none"
            onChange={handleInputChange}
            disabled={isDisabled}
            _disabled={{
              opacity: 1, // Remove the gray-out effect
              cursor: "default", // Prevent the pointer change
            }}
            sx={{
              minHeight: "10px",
              maxHeight: "240px",
            }}
          />
        </FormControl>
      </Box>
    )
}
  
const OptionInput = ({option, currentChosen, setCurrentChosen}) => {
    const RenderOptions = ({options}) => {
        let menuItems = [];
        for (let i = 0; i < options.length; i++) {
            menuItems.push(
                <MenuItem onClick={() => {setCurrentChosen(options[i])}}>
                    {options[i]}
                </MenuItem>
            )
        }
        return menuItems
    }

    return (
      <Box
        display="flex"
        alignItems="center" // Center on the Y-axis
        height="100%" // Parent container height
        bg="#FFFFFF"
        px="12px" // Padding to create space for the left alignment
        py="0px"
      >
        <Menu bg="#FFFFFF">
          <MenuButton as={Button} bg="#FFFFFF">
            {currentChosen}
            <Icon as={ChevronDownIcon} ml={2} />
          </MenuButton>
          <MenuList>
            <RenderOptions options={option.options} />
          </MenuList>
        </Menu>
      </Box>
    )
}

export default QuestionCard;